import SumPanel from '@/views/finance/components/bill/SumPanel'

export default{
  components:{
    SumPanel
  },
  data(){
    return {
      // POS收单汇总
      sumLabel:{
        totalOilAmount:'加油总金额(元)',
        settlementAmount:'应结算总金额(元)',
        totalSlottingAmount:'通道费总金额(元)',
        realSettlementAmount:'实际结算总金额(元)'
      },
      sumInfo:{
        totalOilAmount: '0.00',
        settlementAmount: '0.00',
        totalSlottingAmount: '0.00',
        realSettlementAmount: '0.00'
      },
      tipsInfo: {
        settlementAmount: '加油金额（枪价）- 商家让利金额（合同让利）',
        totalSlottingAmount: '应结算总金额 * 通道费费率',
        realSettlementAmount: '加油金额-基础让利-通道费-商家承担优惠金额-平台承担优惠金额'
      },
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = ''
          }
        },
        // 限制时间选择范围32天
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 31 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      }
    }
  }
}
